
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3 1h18a2 2 0 012 2v18a2 2 0 01-2 2H3a2 2 0 01-2-2V3a2 2 0 012-2zm1.5 2a1.5 1.5 0 000 3h15a1.5 1.5 0 000-3h-15zm0 5a1.5 1.5 0 000 3h15a1.5 1.5 0 000-3h-15zm0 5a1.5 1.5 0 000 3h15a1.5 1.5 0 000-3h-15zm0 5a1.5 1.5 0 000 3h15a1.5 1.5 0 000-3h-15z"}})])
          )
        }
      }
    